import React, {Suspense} from "react";

const LazyLoad = React.forwardRef(({ component: Component, ...rest }, ref) => (
    <Suspense fallback={<span />}>
        <Component ref={ref} {...rest} />
    </Suspense>
));

export default LazyLoad;